import { format } from 'date-fns';

import { getCommonReplacements } from '@src/utils/meta';

import { BASE_URL } from '../../config';
import type { ICreateSchemaParams } from '../../types';

export const buildCollectionPageSchema = ({ seo, path, metadata, currentLocation }: ICreateSchemaParams) => ({
  '@type': 'CollectionPage',
  '@id': `${BASE_URL}${path}#webpage`,
  url: `${BASE_URL}${path}`,
  name: getCommonReplacements({ template: seo.title, meta: metadata, location: currentLocation }),
  description: getCommonReplacements({
    template: seo.description,
    meta: metadata,
    location: currentLocation,
  }),
  inLanguage: 'ru',
  dateModified: format(new Date(), 'yyyy-MM-dd'),
  isPartOf: { '@id': 'https://www.sravni.ru/#website' },
  publisher: { '@id': 'https://www.sravni.ru/#organization' },
  breadcrumb: { '@id': `${BASE_URL}${path}#breadcrumb` },
  mainEntity: { '@id': `${BASE_URL}${path}#offers` },
});
